(function ($){
    $(document).ready(function (){

        // Description Layouts
        $("#descriptionTabs").tabs();

        $("#descriptionAccordion").accordion({
            heightStyle: "content"
        });

      // Back to Top Button
        let backToTop2 = $("#backToTop");
        if ($(window).scrollTop() > 300) { 
            backToTop2.removeClass("hidden");
        
        } 
        $(window).on("scroll", () => {
            if ($(window).scrollTop() < 300) {
                backToTop2.fadeOut(500, () => {
                    backToTop2.addClass("hidden");
                });
            } else {
                backToTop2.fadeIn(500);
                backToTop2.removeClass("hidden");
            }
        });
        backToTop2.on("click", () => {
            $('html, body').animate({ scrollTop:0 }, '300');
        });

    });
})(jQuery);